import React from 'react';
import { Box, Typography } from '@mui/material';
import { tokens } from '../../theme';

// Encabezado de sección consistente: título + subtítulo opcional + acciones
const SectionHeader = ({ title, subtitle, actions, sx }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: subtitle ? 'flex-start' : 'center',
      justifyContent: 'space-between',
      gap: 2,
      mb: 3,
      ...sx,
    }}
  >
    <Box>
      <Typography
        variant="h4"
        sx={{ fontWeight: 600, color: tokens.color.ink.primary, mb: subtitle ? 0.25 : 0 }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" sx={{ color: tokens.color.ink.muted, mt: 0.25 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {actions && (
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexShrink: 0 }}>
        {actions}
      </Box>
    )}
  </Box>
);

export default SectionHeader;
